import quickFetch from 'quick-fetch';
import { createRpcClientV2 } from 'rpc-client-utils';
import { CRM_SEARCH_QUERY } from './graphql';
import { print } from 'graphql/language/printer';
import { handleGQLResult, consumeEarlyCrmSearch } from './early';
import { allPropertiesRequestName, buildSearchCrmObjectsRequest, consumeEarlyCrmSearchAllProperties, handleSalesViewsResult, handleSearchCrmObjectsResult, buildSalesViewsSearchBody, SALES_VIEWS_SEARCH_URL } from './earlyAllProperties';
import { searchCrmObjectsRpc } from '../../../__generated__/chirp/com/hubspot/sales/rpc/ViewServiceRpc';
import { drainSortDurations } from './sortPerfBuffer';
import { Metrics } from '../../utils/metrics';
import { readUserIdFromAuth } from './getUserId';
import { isSearchRpcGateEnabled } from './gate';

// consume/earlyRequest sort filterGroups themselves (for identity matching);
// this just drains and reports the buffered timings once per resolver call.
const reportSortMetrics = () => {
  drainSortDurations().forEach(({
    durationMs,
    context
  }) => {
    Metrics.timer('crm_search_sort_ms', {
      context
    }).update(durationMs);
  });
};

// `args` are passed through unsorted: filterGroup sorting exists only to make
// the early-request identity key match a standard request, and the server is
// filter-order-agnostic, so the fallback fetch has no reason to sort.
const baseFetch = ({
  http,
  args
}) => http.post('/graphql/crm', {
  data: {
    query: print(CRM_SEARCH_QUERY),
    variables: args
  }
}).then(result => handleGQLResult(args.objectTypeId, result.data, result.errors));
const baseFetchAllProperties = ({
  http,
  args,
  userId
}) => http.post(SALES_VIEWS_SEARCH_URL, {
  data: buildSalesViewsSearchBody(args, userId)
}).then(handleSalesViewsResult);
const searchCrmObjects = (http, args, earlyRequestName) => createRpcClientV2({
  hubHttpClient: http
}).call(searchCrmObjectsRpc, {
  request: buildSearchCrmObjectsRequest(args),
  earlyRequestName
}).then(handleSearchCrmObjectsResult);
const fetchAllPropertiesWithRpc = (http, args) => {
  const earlyRequestName = allPropertiesRequestName(args, 'standard');
  if (!quickFetch.getRequestStateByName(earlyRequestName)) {
    return searchCrmObjects(http, args);
  }
  return searchCrmObjects(http, args, earlyRequestName).catch(() => searchCrmObjects(http, args));
};
const fetchAllPropertiesWithRest = (http, args, getUserId) => consumeEarlyCrmSearchAllProperties(args).catch(() => getUserId().catch(() => undefined).then(userId => baseFetchAllProperties({
  http,
  args,
  userId
})));
export const makeCrmSearchRequest = (http, args) => {
  const result = consumeEarlyCrmSearch(args).catch(() => baseFetch({
    http,
    args
  }));
  reportSortMetrics();
  return result;
};
export const makeCrmSearchAllPropertiesRequest = (http, args, getUserId = readUserIdFromAuth) => {
  return isSearchRpcGateEnabled().then(enabled => {
    const result = enabled ? fetchAllPropertiesWithRpc(http, args) : fetchAllPropertiesWithRest(http, args, getUserId);
    reportSortMetrics();
    return result;
  });
};